import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="onusa-container py-40 text-center"><p className="label-x">LOADING…</p></div>;
  if (!user) return <Navigate to="/account" state={{ from: location }} replace />;
  return children;
}
